function equalHeight (container) {
  let currentTallest = 0,
    currentRowStart = 0,
    rowDiv = [],
    el,
    topPosition = 0;
  
  if(Array.isArray(container)) {
    container.forEach(item => {
      el = item;
      el.setAttribute("style", "height: auto");
      topPosition = el.offSetTop;
      if(currentRowStart !== topPosition) {
        for (let row of rowDiv) {
          row.setAttribute("style", `height: ${currentTallest}`);
        }
        rowDiv.length = 0;
        currentRowStart = topPosition;
        currentTallest = el.offsetHeight;
        rowDiv.push(el);
      }
      else {
        rowDiv.push(el);
        currentTallest = (currentTallest < el.offsetHeight ? el.offsetHeight : currentTallest);
      }
      for(let rdiv of rowDiv) {
        rdiv.setAttribute("style", `height: ${currentTallest}`);
      }
    });
  }
}

module.exports.addResize = (elements) => {
  window.onload = equalHeight(elements);
  window.onresize = equalHeight(elements);
  console.log(elements);
}




// WEBPACK FOOTER //
// ./src/Components/Utils/EqualHeight.js